import React, { useState } from 'react';
import useGameStore from './engine/store';
import SetupScreen from './components/SetupScreen';
import TopBar from './components/TopBar';
import LoanCard from './components/LoanCard';
import BankStats from './components/BankStats';
import Charts from './components/Charts';
import MonthResults from './components/MonthResults';
import EventModal from './components/EventModal';
import AchievementToast from './components/AchievementToast';
import GameOverScreen from './components/GameOverScreen';

function LoanReviewPanel() {
  const { pendingLoans, liquidity, month } = useGameStore();

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="p-4 border-b border-white/5">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-bold text-white">📋 Loan Requests</h2>
          <span className="text-xs text-gray-500">Month {month}</span>
        </div>
        <div className="text-xs text-gray-500 mt-1">
          Cash available: <span className="font-mono text-neon-green">${(liquidity / 1e6).toFixed(2)}M</span>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-3 space-y-3">
        {pendingLoans.map(loan => (
          <LoanCard key={loan.id} loan={loan} />
        ))}
      </div>
    </div>
  );
}

function GameScreen() {
  const { phase } = useGameStore();
  const [mobileTab, setMobileTab] = useState(null);

  if (phase === 'results') {
    return (
      <div className="h-screen flex flex-col bg-dark-900 bg-grid overflow-hidden">
        <TopBar />
        <div className="flex-1 overflow-y-auto">
          <MonthResults />
        </div>
        <EventModal />
        <AchievementToast />
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-dark-900 bg-grid overflow-hidden">
      <TopBar />
      <div className="flex-1 flex overflow-hidden">
        {/* Left: Loan Review */}
        <div className="w-[420px] border-r border-white/5 bg-dark-800/40 flex-shrink-0 hidden md:flex flex-col overflow-hidden">
          <LoanReviewPanel />
        </div>

        {/* Center: Charts */}
        <div className="flex-1 overflow-y-auto">
          <Charts />
        </div>

        {/* Right: Bank Stats */}
        <div className="w-72 border-l border-white/5 bg-dark-800/40 flex-shrink-0 hidden lg:flex flex-col overflow-hidden">
          <BankStats />
        </div>
      </div>

      {/* Mobile nav */}
      <MobileNav active={mobileTab} setActive={setMobileTab} />

      <EventModal />
      <AchievementToast />
    </div>
  );
}

function MobileNav({ active, setActive }) {
  return (
    <>
      {active && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/60" onClick={() => setActive(null)} />
          <div className={`absolute inset-y-0 ${active === 'loans' ? 'left-0' : 'right-0'} w-[85vw] max-w-[420px] bg-dark-800 shadow-2xl overflow-hidden`}>
            {active === 'loans' && <LoanReviewPanel />}
            {active === 'stats' && <BankStats />}
          </div>
        </div>
      )}

      <div className="md:hidden h-14 bg-dark-800/90 backdrop-blur-md border-t border-white/5 flex items-center justify-around px-4">
        <button
          onClick={() => setActive(active === 'loans' ? null : 'loans')}
          className={`flex flex-col items-center gap-0.5 ${active === 'loans' ? 'text-neon-green' : 'text-gray-500'}`}
        >
          <span className="text-lg">📋</span>
          <span className="text-xs">Loans</span>
        </button>
        <button
          onClick={() => setActive(null)}
          className={`flex flex-col items-center gap-0.5 ${!active ? 'text-neon-blue' : 'text-gray-500'}`}
        >
          <span className="text-lg">📊</span>
          <span className="text-xs">Charts</span>
        </button>
        <button
          onClick={() => setActive(active === 'stats' ? null : 'stats')}
          className={`flex flex-col items-center gap-0.5 ${active === 'stats' ? 'text-neon-yellow' : 'text-gray-500'}`}
        >
          <span className="text-lg">🏦</span>
          <span className="text-xs">Bank</span>
        </button>
      </div>
    </>
  );
}

export default function App() {
  const { screen } = useGameStore();

  if (screen === 'setup') return <SetupScreen />;
  if (screen === 'gameover') return <GameOverScreen />;
  return <GameScreen />;
}
